const swiperReview = new Swiper('.review-slider__contents', {
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 14,
  centeredSlides: true,
  pagination: {
    el: '.review-pagination',
    clickable: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    980: {
      slidesPerView: 4,
      spaceBetween: 20,
      centeredSlides: false,
    },
  }
});